<!-- @format -->
<script lang="ts">
  import facebook from '@public/theme/mylly2023/assets/mylly-facebook.svg';
  import instagram from '@public/theme/mylly2023/assets/mylly-instagram.svg';
  import tiktok from '@public/theme/mylly2023/assets/mylly-tiktok.png';
  import { type ImageMetadata } from 'astro';

  const ICON: Record<string, ImageMetadata> = {
    facebook,
    instagram,
    tiktok,
  }

  export let social: NavigationMenu | undefined;

  $: links = social?.navigationMenuItems || [];

  const icon = (name: string) => ICON[name.toLowerCase()]?.src;

</script>

{#each links as link}
  <a href={link.url} rel="noreferrer" target="_blank">
    <img class="icon socialmedia-icon" src={icon(link.name)} alt={link.name} />
  </a>
{/each}


<style lang="scss">
  a {
    text-decoration: none;
    img[src$=".png"] {
      background-color: #FFA400;
      border-radius: 22px;
      padding: 10px;
    }
  }

  .socialmedia-icon {
    display: inline-block;
    margin: 0 8px;
    user-select: none;
  }
</style>
